import { render, staticRenderFns } from "./LinkageItem.vue?vue&type=template&id=37113b4a&scoped=true&"
import script from "./LinkageItem.vue?vue&type=script&lang=js&"
export * from "./LinkageItem.vue?vue&type=script&lang=js&"
import style0 from "./LinkageItem.vue?vue&type=style&index=0&id=37113b4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37113b4a",
  null
  
)

export default component.exports